// Constant for Product::Attribute

export const DATATYPE = {
  ENUM    : 'enum',
  PRICE   : 'price',
  BOOLEAN : 'boolean',
  DATE    : 'date',
  INTEGER : 'integer',
  DECIMAL : 'decimal',
  STRING  : 'string'
}

export const UNIT = {
  CENTIMETER : 'cm',
  PERCENTAGE : '%',
  RUPIAH     : 'rupiah',
  GRAM       : 'gram',
  MILIMETER  : 'mm'
}

export const CONTEXT = {
  SYSTEM      : 'system',
  DETAILS     : 'details',
  MEASUREMENT : 'measurement'
}

export const CODE = {
  ANKLE_CIRCUMFERENCE : 'ankle_circumference',
  ARM_CIRCUMFERENCE   : 'arm_circumference',
  BAG_HANDLE_LENGTH   : 'bag_handle_length',
  BOTTOM_LENGTH       : 'bottom_length',
  BOTTOM_WAIST        : 'bottom_waist',
  BOX                 : 'box',
  BOX_HEIGHT          : 'box_height',
  BOX_LENGTH          : 'box_length',
  BOX_WIDTH           : 'box_width',
  BRAND               : 'brand',
  BRIDGE_LENGTH       : 'bridge_length',
  CATEGORY            : 'category',
  CERTIFICATE         : 'certificate',
  CHAIN_LENGTH        : 'chain_length',
  CHEST_CIRCUMFERENCE : 'chest_circumference',
  COLLECTION          : 'collection',
  COLOUR              : 'colour',
  CONDITION           : 'condition',
  DEFECT              : 'has_defect',
  DESCRIPTION         : 'description',
  DIAMETER            : 'diameter',
  DIMENSION           : 'dimension',
  DUSTBAG             : 'dustbag',
  FABRIC              : 'fabric',
  HEEL_HEIGHT         : 'heel_height',
  HEIGHT              : 'height',
  HIP_CIRCUMFERENCE   : 'hip_circumference',
  IMAGES              : 'images',
  INSEAM              : 'inseam',
  INSOLE              : 'insole',
  LENGTH              : 'length',
  LENS_HEIGHT         : 'lens_height',
  LENS_WIDTH          : 'lens_width',
  LIVE_DATE           : 'live_date',
  MAIN_IMAGE          : 'main_image',
  MAKE_UP_EXPIRY_DATE : 'make_up_expiry_date',
  MAKE_UP_FILL        : 'make_up_fill',
  MAKE_UP_SIZE        : 'make_up_size',
  MATERIAL            : 'material',
  NAME                : 'name',
  NOTE                : 'note',
  PATTERN             : 'pattern',
  PRICE               : 'price',
  QUANTITY            : 'quantity',
  SELLER              : 'seller',
  SELLING_PRICE       : 'selling_price',
  SHADE               : 'shade',
  SHOULDER_LENGTH     : 'shoulder_length',
  SKU                 : 'sku',
  SLEEVE_LENGTH       : 'sleeve_length',
  STATUS              : 'status',
  STRAP_LENGTH        : 'strap_length',
  STRETCH             : 'stretch',
  TEMPLE_LENGTH       : 'temple_length',
  TINY_DIAMETER       : 'tiny_diameter',
  TOP_HIP             : 'top_hip',
  TOP_LENGTH          : 'top_length',
  URL_KEY             : 'url_key',
  WAIST_CIRCUMFERENCE : 'waist_circumference',
  WEIGHT              : 'weight',
  WIDTH               : 'width',
  WRIST_CIRCUMFERENCE : 'wrist_circumference'
}

// Status for product attribute model reference
export const STATUS_OPTION = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}
